import { useState, useCallback } from "react";
import { WEIGHT_UNITS } from "../../utils/calculators/constants";

// Provides consistent weight input state and handlers across all calculators
export const useWeightInput = (defaultUnit = "kg") => {
  const [weightValue, setWeightValue] = useState("");
  const [weightUnit, setWeightUnit] = useState(defaultUnit);

  const clearWeightError = useCallback((setErrors) => {
    if (setErrors) {
      setErrors((prev) => ({ ...prev, weight: "" }));
    }
  }, []);

  const handleWeightChange = useCallback((e, setErrors) => {
    const newValue = e.target.value.replace(/^0+/, "");
    setWeightValue(newValue);
    clearWeightError(setErrors);
  }, [clearWeightError]);

  const handleWeightUnitChange = useCallback((e, setErrors) => {
    const newUnit = e.target.value;
    if (newUnit !== weightUnit) {      
      setWeightValue("");
    }
    setWeightUnit(newUnit);
    clearWeightError(setErrors);
  }, [weightUnit, clearWeightError]);

  const clearWeightFields = useCallback(() => {
    setWeightValue("");
    setWeightUnit(defaultUnit);
  }, [defaultUnit]);

  return {
    
    weightValue,
    weightUnit,
    
    handleWeightChange,
    handleWeightUnitChange,
    clearWeightFields,
    
    setWeightValue,
    setWeightUnit,
    // legacy aliases for backward compatibility
    setWeight: setWeightValue,

    unitOptions: WEIGHT_UNITS,
  };
};

export default useWeightInput;
